
import { AuthCookies } from 'mroshopcommon/src/utils/cookie';
class Auth extends AuthCookies {
  constructor() {
    super('ZdClound-Token');
  }
}

export default new Auth();
